import { render, staticRenderFns } from "./FacilityEditTabNote.vue?vue&type=template&id=13f18f0e&"
import script from "./FacilityEditTabNote.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports